export default "__VITE_ASSET__C9wLIKqQ__"